export enum DeviceExperience {
  NotSet = 'NotSet',
  Personal = 'Personal',
  Shared = 'Shared',
}
